import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  createConsentPayload,
  defaultCookiePreferences,
  getStoredCookieConsent,
  requiredCookiePreferences,
  saveCookieConsent,
  updateConsentSignals,
} from "../../utils/cookieConsent";

const OPTIONAL_COOKIE_CATEGORIES = ["statistics", "marketing"];

const CookieConsentBanner = () => {
  const { t } = useTranslation();
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [cookiePreferences, setCookiePreferences] = useState(
    defaultCookiePreferences
  );

  useEffect(() => {
    const storedConsent = getStoredCookieConsent();

    if (storedConsent) {
      updateConsentSignals(storedConsent.categories);
    } else {
      setShowCookieBanner(true);
    }
  }, []);

  const confirmCookieConsent = (mode, categories) => {
    saveCookieConsent(createConsentPayload(mode, categories));
    setShowCookieBanner(false);
  };

  const toggleCookiePreference = (category) => {
    setCookiePreferences((currentPreferences) => ({
      ...currentPreferences,
      [category]: !currentPreferences[category],
    }));
  };

  if (!showCookieBanner) {
    return null;
  }

  return (
    <section className="cookie-consent-bar" aria-label={t("cookie.title")}>
      <div className="cookie-consent-copy">
        <h2>{t("cookie.title")}</h2>
        <p>{t("cookie.text_1")}</p>
        <p dangerouslySetInnerHTML={{ __html: t("cookie.text_2") }}></p>
        <Link className="cookie-policy-mobile-link" to="/privacy-policy">
          {t("cookie.policyLink")}
        </Link>
      </div>
      <div className="cookie-consent-controls">
        <div className="cookie-category-list">
          <label className="cookie-category-toggle">
            <span>
              <strong>{t("cookie.categories.necessary.title")}</strong>
              <small>{t("cookie.categories.necessary.description")}</small>
            </span>
            <input
              type="checkbox"
              checked
              disabled
              aria-label={t("cookie.categories.necessary.title")}
              readOnly
            />
          </label>
          {OPTIONAL_COOKIE_CATEGORIES.map((category) => (
            <label className="cookie-category-toggle" key={category}>
              <span>
                <strong>{t(`cookie.categories.${category}.title`)}</strong>
                <small>{t(`cookie.categories.${category}.description`)}</small>
              </span>
              <input
                type="checkbox"
                checked={cookiePreferences[category]}
                onChange={() => toggleCookiePreference(category)}
                aria-label={t(`cookie.categories.${category}.title`)}
              />
            </label>
          ))}
        </div>
        <div className="cookie-consent-actions">
          <button
            className="cookie-action-button primary"
            onClick={() =>
              confirmCookieConsent("allow_all", defaultCookiePreferences)
            }
          >
            {t("cookie.actions.allowAll")}
          </button>
          <button
            className="cookie-action-button secondary"
            onClick={() => confirmCookieConsent("custom", cookiePreferences)}
          >
            {t("cookie.actions.saveSelection")}
          </button>
          <button
            className="cookie-action-button ghost"
            onClick={() =>
              confirmCookieConsent("reject_optional", requiredCookiePreferences)
            }
          >
            {t("cookie.actions.rejectOptional")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default CookieConsentBanner;
